import React from 'react';
import { ItemOption } from '../ItemOption/ItemOption';
import './MenuList.css';

export class MenuList extends React.Component {
    constructor(props) {
        super(props);
        this.renderItems = this.renderItems.bind(this);
    }
    renderItems() {
        return (
            <div className = "items">
                {this.props.items.map(item => {
                    return <ItemOption showModal = {this.props.showModal} category = {this.props.category} name = {item.name} description = {item.description} />
                })}
            </div>
        )
    }
    render() {
        return(
            <div className = "menu-list" id = {`${this.props.category}-list`}>
                <h2> {this.props.category}</h2>
                {this.renderItems()}
            </div>
        );
    }

}